import type { SensorPositionId } from '@/feature/equipment/configuration/api';
import type { MeasurementSystem } from '@/feature/userPreference/api.types';

export interface DataStreamRequest {
  equipmentIds: string[];
  measurementSystem: MeasurementSystem;
  subscriptions: Subscription[];
}

export type Subscription = SampleSubscription | AlarmCountSubscription;

export type DataStreamResponse = SampleResponse | AlarmCountResponse;

/**
 * Sample
 */
export interface SampleSubscription {
  type: 'sample';
  signalNames: string[];
  includeLatest?: boolean;
  equipmentIds?: string[];
}

export function isSampleSubscription(
  subscription: Subscription
): subscription is SampleSubscription {
  return subscription.type === 'sample';
}

export interface SampleResponse {
  type: 'sample';
  timeStamp: string;
  equipmentId: string;
  signalName: string;
  value: number | null;
  position?: string;
  positionId?: SensorPositionId;
  positionSignalName?: string;
}

export function isSampleResponse(
  response: DataStreamResponse
): response is SampleResponse {
  return response.type === 'sample';
}

/**
 * Alarm count
 */
export interface AlarmCountSubscription {
  type: 'alarm:count';
  includeLatest?: boolean;
  equipmentIds?: string[];
}

export function isAlarmCountSubscription(
  subscription: Subscription
): subscription is AlarmCountSubscription {
  return subscription.type === 'alarm:count';
}

export interface AlarmCountResponse {
  type: 'alarm:count';
  timeStamp: string;
  equipmentId: string;
  alarmCount: number;
}

export function isAlarmCountResponse(
  response: DataStreamResponse
): response is AlarmCountResponse {
  return response.type === 'alarm:count';
}
